import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNav from '../Header/AdminNav';


export default function AdminLayout() {
  return (
    <div className="docpro_admin_layout_wrap">
      <h3 className="docpro_admin_layout_title">Admin</h3>
      <div className="docpro_admin_layout">
        <div className="docpro_admin_layout_left">
          <AdminNav />
        </div>
        <div className="docpro_admin_layout_right">
          <Outlet />
        </div>
      </div>
    </div>
  );
}